import React from 'react'
import { TextField, Typography, Button, Grid, Link, InputAdornment } from '@mui/material';
import colors from '../../colors'
import * as config from '../../config'
import { useSelector, useDispatch } from 'react-redux';
import { selectRegistrationState, decrementCurrentRegistrationStep, setPhone, setPrefix, setIsForeignNumber } from '../../../features/registration/registrationSlice'
import { sendGeneralRequest } from '../../../features/generalRequest'
import { useFormik } from 'formik'
import * as yup from 'yup'
import RegistrationPasswordTextValidator from '../../general/RegistrationPasswordTextValidator';
import { MuiTelInput } from 'mui-tel-input'
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { makeStyles } from '@mui/styles';
import { texts } from '../../general/texts'
import ReCAPTCHA from "react-google-recaptcha"
import { setIsManualRegistration } from '../../../features/login/loginSlice';
import OtpInput from 'react-otp-input';

const FirstRegistrationStep = (props) => {
    const dispatch = useDispatch()
    const registrationSliceState = useSelector(selectRegistrationState)
    const validationSchema = yup.object({
        email: yup
            .string(texts["message-invalid-email"])
            .email(texts["message-invalid-email"])
            .required(texts["message-invalid-email"]),
        password: yup
            .string(texts["message-invalid-password"])
            .min(6, texts["message-invalid-password"])
            .required(texts["message-invalid-password"]),
        fullPhoneNumber: yup
            .string(texts["message-invalid-phone"])
            .required(texts["message-invalid-phone"]),
        pin: yup
            .string(texts["message-invalid-pin-field"])
            .length(6, texts["message-invalid-pin-field"])
            .matches(/^\d{6}$/, texts["message-invalid-pin-field"])
            .required(texts["message-invalid-pin-field"]),
        idTC: yup
            .bool()
            .oneOf([true], "You must accept the terms and conditions"),
        ...(registrationSliceState.accountType === 2) && {
            NUIS: yup
                .string()
                // .matches( /^[a-zA-Z][a-zA-Z0-9]{8}[a-zA-Z]$/, {
                //     message:(texts["message-invalid-nuis"]),
                // })
                .required(texts["message-invalid-nuis"]),
        }
    });
    const formik = useFormik({
        initialValues: {
            isCaptchaVerified: false,
            email: '',
            password: '',
            phone: '',
            pin: '',
            NUIS: '',
            prefix: '355',
            fullPhoneNumber: '',
            accountType: registrationSliceState.accountType,
            AppPlatform: config.default.appPlatform,
            AppVersionName: config.default.appVersion,
            DeviceName: config.default.userBrowserName,
            DeviceOS: config.default.userBrowserVersion
        },
        validationSchema: validationSchema,
        onSubmit: values => {
            if (values.isCaptchaVerified) {
                dispatch(setPhone(values.phone))
                dispatch(setPrefix(values.prefix))
                // {values.prefix !== '355' && dispatch(setIsForeignNumber(true))}
                dispatch(sendGeneralRequest({ request: { _request: { ...values, prefix: values.prefix } }, baseUrlKey: 'auth', endpoint: 'RegisterNew' })).then(response => {
                    if (response.payload.response.success) {
                        dispatch(setIsManualRegistration(response.payload.response.isManualRegistration))
                    }
                })
            }
        }
    })

    const [showPassword, setShowPassword] = React.useState(false);

    const handlePhoneNumberChange = (value, info) => {
        formik.setFieldValue("fullPhoneNumber", value)
        formik.setFieldValue("prefix", info.countryCallingCode)
        formik.setFieldValue("phone", info.nationalNumber)
    }

    const captchaOnChange = () => {
        formik.setFieldValue("isCaptchaVerified", !formik.values.isCaptchaVerified)
    }

    const handleOtpChange = (pin) => {
        formik.setFieldValue('pin', pin)
    }

    const useStyles = makeStyles({
        mainGrid: {
            width: '60%',
            paddingLeft: '9.5%',
            '@media (max-width: 1440px)': { width: '70%' },
            '@media (max-width: 1024px)': { width: '85%' },
            '@media (max-width: 768px)': { width: '80%' },
            '@media (max-width: 425px)': { width: '90%' }
        },
        fieldTitle: {
            color: colors.orange,
            fontSize: '1.2rem',
            fontFamily: 'GerberaMedium'
        },
        textField: {
            width: '60%',
            '@media (max-width: 899px)': { width: '90%' }
        },
        inputAdornment: {
            background: colors.white,
            color: colors.darkBlue,
            borderRadius: '100%',
            height: '5px',
            '&:hover': { background: colors.white }
        },
        button: {
            background: colors.gradientOrange,
            color: colors.white,
            width: '12%',
            fontFamily: 'GerberaBold',
            textTransform: 'none',
            fontSize: '1rem',
            '@media (max-width: 899px)': { width: '40%' }
        },
        link: {
            color: colors.orange,
            textDecorationColor: colors.orange,
            fontFamily: 'GerberaLight',
            '@media (max-width: 899px)': { marginTop: 1, marginBottom: 5 },
            "&:hover": { textDecorationColor: '#FF8403', color: '#FF8403' }
        }
    })

    const classes = useStyles()

    return (
        <form onSubmit={formik.handleSubmit}>
            <Grid container justifyContent='center' width={'100%'}>
                <Grid container item className={classes.mainGrid} >
                    {registrationSliceState.accountType === 2 && <Grid container item md={6} xs={12} flexDirection='column' marginBottom={10}>
                        <Grid container item justifyContent={'flex-start'} mb={2}><Typography className={classes.fieldTitle} >{texts["title-registration-nipt"]}</Typography></Grid>
                        <Grid container item justifyContent='flex-start'><TextField id="NUIS" name="NUIS" label={texts["placeholder-nuis"]} onChange={formik.handleChange} value={formik.values.NUIS} error={formik.touched.NUIS && Boolean(formik.errors.NUIS)} helperText={formik.touched.NUIS && formik.errors.NUIS} color="warning" variant="standard" className={classes.textField} /></Grid>
                    </Grid>}
                    <Grid container item md={6} xs={12} flexDirection='column' marginBottom={10}>
                        <Grid container item justifyContent='flex-start' mb={2}>{registrationSliceState.accountType === 2 ? <Typography className={classes.fieldTitle} >{texts["title-registration-email-business"]}</Typography> : <Typography className={classes.fieldTitle}>{texts["title-registration-email"]}</Typography>}</Grid>
                        <Grid container item justifyContent='flex-start'><TextField id="email" name="email" label={texts["placeholder-email"]} onChange={formik.handleChange} value={formik.values.email} error={formik.touched.email && Boolean(formik.errors.email)} helperText={formik.touched.email && formik.errors.email} color="warning" variant="standard" className={classes.textField} /></Grid>
                    </Grid>
                    <Grid container item md={6} xs={12} flexDirection='column' marginBottom={10}>
                        <Grid container item justifyContent='flex-start' mb={3.5}><Typography className={classes.fieldTitle} >{texts["placeholder-phone-number"]}</Typography></Grid>
                        <Grid container item justifyContent='flex-start' mb={2}>
                            <MuiTelInput id="fullPhoneNumber" name="fullPhoneNumber" placeholder={texts["placeholder-phone-number"]} value={formik.values.fullPhoneNumber} defaultCountry='AL' onChange={handlePhoneNumberChange} error={formik.touched.fullPhoneNumber && Boolean(formik.errors.fullPhoneNumber)} helperText={formik.touched.fullPhoneNumber && formik.errors.fullPhoneNumber} color="warning" variant="standard" className={classes.textField} />
                        </Grid>
                    </Grid>
                    <Grid container item md={6} xs={12} flexDirection='column' >
                        <Grid container item justifyContent='flex-start' mb={2}><Typography className={classes.fieldTitle} >{texts["title-registration-password"]}</Typography></Grid>
                        <Grid container item justifyContent='flex-start' mb={2}><TextField id="password" name="password" autoComplete="off" label={texts["placeholder-password"]} onChange={formik.handleChange} value={formik.values.password} error={formik.touched.password && Boolean(formik.errors.password)} helperText={formik.touched.password && formik.errors.password} color="warning" type={showPassword ? "text" : "password"} variant="standard" InputProps={{ endAdornment: <InputAdornment position="end"><Button disableRipple={true} onClick={() => setShowPassword(s => !s)} className={classes.inputAdornment} >{showPassword === false && <VisibilityIcon />}{showPassword === true && <VisibilityOffIcon />}</Button></InputAdornment> }} className={classes.textField} /></Grid>
                        <Grid container item justifyContent='flex-start' mb={2}>
                            <RegistrationPasswordTextValidator password={formik.values.password} />
                        </Grid>
                    </Grid>
                    <Grid container item md={6} xs={12} flexDirection='column' marginBottom={10}>
                        <Grid container item justifyContent='flex-start' mb={2}><Typography className={classes.fieldTitle} >{texts["title-registration-pin"]}</Typography></Grid>
                        <Grid justifyContent={'center'} >
                            <OtpInput
                                value={formik.values.pin}
                                onChange={handleOtpChange}
                                numInputs={6}
                                isInputNum
                                inputStyle={{
                                    width: '2rem',
                                    height: '2.5rem',
                                    borderTop: 'none',
                                    borderLeft: 'none',
                                    outline: 'none',
                                    borderRight: 'none',
                                    fontFamily: 'GerberaLight',
                                    borderBottom: '1px solid gray',
                                    transition: 'border-color 0.2s ease-in-out',
                                    color: colors.darkBlue,
                                    fontSize: '1.5rem',
                                    paddingBottom: '3%',
                                    height: '60%',
                                    marginBottom: '50px',
                                    textAlign: 'center',
                                    marginRight: '0.5rem',
                                }}
                                renderInput={(props) => <input {...props} type="password" />}
                            />
                        </Grid>
                        {formik.touched.pin && formik.errors.pin && (
                            <Typography color="error" sx={{ mt: 1, textAlign: 'start', fontSize: '0.75rem' }}>
                                {formik.errors.pin}
                            </Typography>
                        )}
                    </Grid>
                    <Grid container item md={6} xs={12} flexDirection='column' >
                        <Grid container item justifyContent='flex-start' mb={2}><Typography className={classes.fieldTitle} >{"Captcha"}</Typography></Grid>
                        <Grid container item justifyContent='flex-start' mb={2}>
                            <ReCAPTCHA sitekey={"6LfFQLcjAAAAAJC92Al85--AqhNfJET_DJl4SBdP"} onChange={captchaOnChange} />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid container item md={12} xs={12} mt={registrationSliceState.accountType === 2 ? 1 : 7} justifyContent={'center'}  >
                    <Button disabled={registrationSliceState.isLoading ? true : false} type='submit' className={classes.button}>{texts["button-continue"]}</Button>
                </Grid>
                <Grid item md={12} xs={12} pt={'0.8%'} >
                    <Link disabled={registrationSliceState.isLoading ? true : false} className={classes.link} onClick={() => { dispatch(decrementCurrentRegistrationStep()) }} component='button' variant='body2'>{texts["button-back"]}</Link>
                </Grid>
            </Grid>
        </form>
    );
}

export default FirstRegistrationStep